import React, { useMemo } from "react";
import Dropdown from "components/Elements/Dropdown";
import { ReportFormatOptions, ReportFormats } from "constants/reportSubscriptions";
import FieldLabel from "./FieldLabel";

// `availableFormats` is an optional whitelist supplied per-report (e.g. an
// Excel-only report passes `["Excel"]`). When omitted, all formats are shown.
const FormatPickerField = ({ value, onChange, availableFormats, disabled }) => {
	const options = useMemo(() => {
		if (!availableFormats || !availableFormats.length) return ReportFormatOptions;
		return ReportFormatOptions.filter((o) => availableFormats.includes(o.value));
	}, [availableFormats]);

	const selected = options.find((o) => o.value === value) || {};

	return (
		<div>
			<FieldLabel required>Format</FieldLabel>
			<Dropdown
				options={options}
				selectedValue={selected}
				onChange={(opt) => onChange(opt.value)}
				placeholder={disabled ? "Select a report first" : "Select a format"}
				width="100%"
				disabled={disabled}
				hideSearch
			/>
		</div>
	);
};

FormatPickerField.formats = ReportFormats;

export default FormatPickerField;
